import React, { FC, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import {
  BoxFieldRangeUnit,
  TenderBlockSize,
  TenderBoxMode,
  TenderSubCatName
} from 'src/models/procurements/Tender/types';
import { Translations } from 'src/lib/I18nService/types';
import { TenderBox, TenderSubCat } from 'src/shared';
import { useTenderFree } from 'src/models/procurements/TenderFree/hooks';
import {
  BoxFieldCurrency,
  BoxFieldDate,
  BoxFieldNumber,
  BoxFieldString,
  TenderBoxFactory
} from 'src/models/procurements';

export const ContractSubCat: FC = () => {
  const { t } = useTranslation();
  const { t: tenderT } = useTranslation(Translations.procurements);
  const { data } = useTenderFree();
  const subCat = data?.generalCat[TenderSubCatName.Contract];
  const startBox = useMemo(
    () =>
      subCat?.contractStart
        ? new TenderBoxFactory().create('contractStartAndEndStart', [new BoxFieldDate('', subCat.contractStart)])
        : undefined,
    [subCat?.contractStart]
  );
  const endBox = useMemo(
    () =>
      subCat?.contractEnd
        ? new TenderBoxFactory().create('contractStartAndEndEnd', [new BoxFieldDate('', subCat.contractEnd)])
        : undefined,
    [subCat?.contractEnd]
  );
  const estimValueBox = useMemo(
    () =>
      subCat?.estValue
        ? new TenderBoxFactory().create('contractValueBoxes', [
            new BoxFieldCurrency('', subCat.estValue.amount, subCat.estValue.currency)
          ])
        : undefined,
    [subCat?.estValue]
  );
  const durationBox = useMemo(
    () =>
      subCat?.contractDuration
        ? new TenderBoxFactory().create('contractDurationBoxes', [
            new BoxFieldNumber('', subCat.contractDuration, BoxFieldRangeUnit.Days)
          ])
        : undefined,
    [subCat?.contractDuration]
  );
  const renewalBox = useMemo(
    () =>
      subCat?.contractRenewal
        ? new TenderBoxFactory().create('contractRenewalBoxes', [
            new BoxFieldString(subCat.contractRenewal.toString(), subCat.contractRenewal)
          ])
        : undefined,
    [subCat?.contractRenewal]
  );

  return (
    <>
      {subCat && (
        <TenderSubCat subCat={{ ...subCat, size: TenderBlockSize.Half }}>
          <TenderBox
            box={startBox}
            title={tenderT('Contract start date')}
            as={TenderBoxMode.Custom}
            size={TenderBlockSize.Half}
            actions={false}
            isFirstField
          />
          <TenderBox
            box={endBox}
            title={tenderT('Contract end date')}
            as={TenderBoxMode.Custom}
            size={TenderBlockSize.Half}
            actions={false}
            isFirstField
          />
          <TenderBox
            box={estimValueBox}
            title={t('Estimated contract value')}
            as={TenderBoxMode.Custom}
            size={TenderBlockSize.Half}
            actions={false}
            isFirstField
          />
          <TenderBox
            box={durationBox}
            title={t('Contract duration')}
            as={TenderBoxMode.Custom}
            size={TenderBlockSize.Half}
            actions={false}
            isFirstField
          />
          <TenderBox
            box={renewalBox}
            title={tenderT('Contract renewal')}
            as={TenderBoxMode.Custom}
            size={TenderBlockSize.Half}
            actions={false}
            isFirstField
          />
        </TenderSubCat>
      )}
    </>
  );
};

export default ContractSubCat;
